import { EditorialProject } from '../types/EditorialProject.types';

// Un proyecto por cada una de las 4 fases del flujo editorial, para poder ver
// el módulo completo (evaluación, contratación, producción y cierre) sin
// tener que ir avanzando fases a mano.
export const MOCK_EDITORIAL_PROJECTS: EditorialProject[] = [
  {
    id: 'PRJ-ED-01',
    name: 'Edición Crítica de Don Quijote de la Mancha',
    responsableId: 'USR-002',
    responsableName: 'Elena Martínez',
    bookTitle: 'Don Quijote de la Mancha (Edición Crítica)',
    bookAuthor: 'Miguel de Cervantes',
    bookCategory: 'Ficción Clásica',
    modality: 'propia',
    editorialPhase: 'produccion',
    formats: [
      { name: 'Tapa Dura al Cromo', price: 35.00 },
      { name: 'Rústica con Solapas', price: 19.90 },
      { name: 'E-book ePub3', price: 9.99 }
    ],
    tiradas: [
      { id: 'TIR-001', editionName: '1ª Edición Crítica Conmemorativa', quantity: 2000, date: '2026-05-10' },
      { id: 'TIR-002', editionName: 'Reimpresión Especial Q2', quantity: 1500, date: '2026-07-15' }
    ],
    humanResources: [
      { id: 'HR-001', name: 'Elena Martínez (Coordinación)', estimatedHours: 80, hourlyCost: 32, totalEstimatedCost: 2560 },
      { id: 'HR-002', name: 'Estudio Externo (Corrección de estilo)', estimatedHours: 120, hourlyCost: 25, totalEstimatedCost: 3000 },
      { id: 'HR-003', name: 'Maquetador Freelance', estimatedHours: 60, hourlyCost: 30, totalEstimatedCost: 1800 }
    ],
    physicalResources: [
      { id: 'PHYS-001', name: 'Adquisición derechos grabados históricos', cost: 1200 },
      { id: 'PHYS-002', name: 'Planchas de impresión zinc offset', cost: 950 }
    ],
    globalBudget: 12000,
    expenses: [
      { id: 'EXP-001', concept: 'Honorarios Corrector', category: 'RRHH', amount: 3000, date: '2026-05-20', description: 'Pago completo corrector externo contratado' },
      { id: 'EXP-002', concept: 'Adquisición derechos grabados', category: 'Licencia', amount: 1200, date: '2026-06-02', description: 'Derechos de uso perpetuo de grabados de Doré' },
      { id: 'EXP-003', concept: 'Entrega parcial Maquetación', category: 'RRHH', amount: 900, date: '2026-06-15', description: 'Primer hito de maquetación de rústica' }
    ],
    status: 'editing',
    startDate: '2026-05-01',
    targetReleaseDate: '2026-10-15',
    notes: 'Proyecto conmemorativo de fondo editorial. Contrato firmado por DocuSign, en fase activa de maquetación y pruebas de galeradas.',
    proposalDetails: {
      isSolicited: true,
      genre: 'Edición Filológica y Crítica',
      collection: 'Clásicos Universales Albatross',
      synopsis: 'Fijación textual exhaustiva con 1.400 notas a pie de página y grabados de Gustave Doré digitalizados en alta resolución.',
      targetAudience: 'Comunidad universitaria, bibliotecas y lectores de ediciones de lujo.',
      proposalDate: '2026-01-15',
      agentOrAgency: 'Fundación Patrimonio Cervantino',
      crmContactId: 'CRM-AG-004',
      crmSyncEnabled: true,
      presaleEnabled: true
    },
    zeroReader: {
      assignedReader: 'Pedro Sánchez (Comité)',
      deadline: '2026-02-28',
      report: {
        completed: true,
        narrativeQuality: 5,
        commercialViability: 4,
        technicalRigor: 5,
        catalogFit: 5,
        recommendation: 'publicar',
        evaluatorNotes: 'Texto canónico impecable. El aparato crítico aportado por el equipo investigador es de primer nivel europeo. Publicación recomendada de manera prioritaria.',
        evaluationDate: '2026-02-20'
      }
    },
    editorialBoardDecision: {
      decision: 'aprobado',
      decisionDate: '2026-03-05',
      comments: 'Aprobado por unanimidad en Mesa Editorial ordinaria. Se aprueba presupuesto de 12.000€ y pase inmediato a Contratación.'
    },
    contractDetails: {
      status: 'signed',
      docusignEnvelopeId: 'DOCUSIGN-ENV-88419-CERV',
      signedDate: '2026-03-18',
      advanceAmount: 2500,
      advanceAmortized: 0,
      advanceTreasuryPaid: true,
      royaltyTiers: [
        { upToQty: 2000, rate: 8 },
        { upToQty: 5000, rate: 10 },
        { upToQty: 999999, rate: 12 }
      ],
      territory: 'España y Unión Europea',
      authorizedLanguages: ['Castellano Antiguo y Moderno'],
      authorizedFormats: ['Tapa Dura', 'Rústica', 'Digital ePub'],
      durationYears: 10,
      exclusivity: true
    },
    technicalSheet: {
      subtitle: 'Texto fijado y anotado por el Instituto de Estudios Clásicos',
      translator: 'N/A (Original en castellano)',
      illustrator: 'Gustave Doré (Grabados restaurados)',
      isbnPrint: '978-84-15982-10-4',
      isbnDigital: '978-84-15982-11-1',
      legalDeposit: 'M-14892-2026',
      formatSize: '17 x 24 cm (Especial Biblioteca)',
      pageCount: 1120,
      paperType: 'Coral Book Ahuesado 80g de alta opacidad',
      bindingType: 'Cosido con hilo vegetal, lomo redondo y cabezadas de tela',
      coverLamination: 'Geltex tela con estampación en oro y sobrecubierta soft-touch con reserva UVI'
    },
    costEscandallo: {
      services: [
        { id: 'SCE-01', concept: 'Fijación de texto y cotejo de variantes', budgeted: 2800, actual: 2800, provider: 'Dra. Carmen Vidal', purchaseOrderGenerated: true },
        { id: 'SCE-02', concept: 'Corrección ortotipográfica y de estilo', budgeted: 1500, actual: 1600, provider: 'Correcciones Ágora S.L.', purchaseOrderGenerated: true },
        { id: 'SCE-03', concept: 'Maquetación interior y composición tipográfica', budgeted: 1800, actual: 900, provider: 'Taller Tipográfico Norte', purchaseOrderGenerated: true },
        { id: 'SCE-04', concept: 'Restauración y retoque digital de grabados', budgeted: 1200, actual: 1200, provider: 'Artes Visuales S.L.', purchaseOrderGenerated: true }
      ],
      industrials: [
        { id: 'IND-01', concept: 'Papel Torraspapel Ahuesado 80g (Tirada 2.000)', budgeted: 2400, actual: 2450, provider: 'Torraspapel Distribución', purchaseOrderGenerated: true },
        { id: 'IND-02', concept: 'CTP y planchas térmicas offset de alta definición', budgeted: 850, actual: 850, provider: 'Marcial Pons Gráficas', purchaseOrderGenerated: true },
        { id: 'IND-03', concept: 'Impresión de pliegos 2 tintas', budgeted: 1950, actual: 0, provider: 'Marcial Pons Gráficas', purchaseOrderGenerated: false },
        { id: 'IND-04', concept: 'Encuadernación en tela estampada con sobrecubierta', budgeted: 2200, actual: 0, provider: 'Encuadernaciones Artesanales Madrid', purchaseOrderGenerated: false }
      ]
    },
    ganttSchedule: [
      { id: 'TSK-01', taskName: 'Recepción manuscrito y aparato crítico', assignee: 'Elena Martínez', startDate: '2026-05-01', endDate: '2026-05-15', progressPct: 100, dependencies: [] },
      { id: 'TSK-02', taskName: 'Corrección de estilo y notas de texto', assignee: 'Correcciones Ágora', startDate: '2026-05-16', endDate: '2026-06-10', progressPct: 100, dependencies: ['TSK-01'] },
      { id: 'TSK-03', taskName: 'Maquetación base de interiores', assignee: 'Taller Tipográfico', startDate: '2026-06-11', endDate: '2026-07-05', progressPct: 70, dependencies: ['TSK-02'] },
      { id: 'TSK-04', taskName: 'Primera revisión de galeradas / Pruebas', assignee: 'Elena Martínez', startDate: '2026-07-06', endDate: '2026-07-25', progressPct: 40, dependencies: ['TSK-03'] },
      { id: 'TSK-05', taskName: 'Aprobación definitiva e Imprimátur', assignee: 'Pedro Sánchez (Director)', startDate: '2026-07-26', endDate: '2026-08-05', progressPct: 0, dependencies: ['TSK-04'], isImprimatur: true },
      { id: 'TSK-06', taskName: 'CTP e Impresión en Marcial Pons', assignee: 'Marcial Pons Gráficas', startDate: '2026-08-06', endDate: '2026-09-10', progressPct: 0, dependencies: ['TSK-05'] },
      { id: 'TSK-07', taskName: 'Encuadernación y entrega en Almacén', assignee: 'Logística Albatross', startDate: '2026-09-11', endDate: '2026-10-01', progressPct: 0, dependencies: ['TSK-06'] }
    ],
    imprimatur: {
      approved: false,
      signedBy: undefined,
      signedDate: undefined,
      versionNotes: 'Galerada V2 en corrección final de índices analíticos.'
    }
  },
  {
    id: 'PRJ-ED-02',
    name: 'Manual de Derecho Financiero y Tributario 2026',
    responsableId: 'USR-004',
    responsableName: 'Ana Belén',
    bookTitle: 'Manual de Derecho Financiero y Tributario (12ª Ed.)',
    bookAuthor: 'Dra. María Sánchez',
    bookCategory: 'Derecho y Economía',
    modality: 'encargo',
    clientName: 'Consejo General de Economistas y Notarios',
    editorialPhase: 'contratacion',
    formats: [
      { name: 'Rústica Fresada', price: 45.00 },
      { name: 'Licencia Digital Universitaria', price: 19.99 }
    ],
    tiradas: [
      { id: 'TIR-003', editionName: '1ª Tirada Académica', quantity: 1200, date: '2026-06-01' }
    ],
    humanResources: [
      { id: 'HR-004', name: 'Dra. María Sánchez (Revisión)', estimatedHours: 40, hourlyCost: 50, totalEstimatedCost: 2000 },
      { id: 'HR-005', name: 'Ana Belén (Edición)', estimatedHours: 50, hourlyCost: 24, totalEstimatedCost: 1200 }
    ],
    physicalResources: [
      { id: 'PHYS-003', name: 'Planchas y fotolitos', cost: 2200 },
      { id: 'PHYS-004', name: 'Distribución y muestras académicas', cost: 600 }
    ],
    globalBudget: 8000,
    expenses: [
      { id: 'EXP-004', concept: 'Adelanto Derechos de Autor', category: 'Licencia', amount: 3000, date: '2026-05-12', description: 'Pago de anticipo según contrato mercantil' },
      { id: 'EXP-005', concept: 'Honorarios Revisora Científica', category: 'RRHH', amount: 2000, date: '2026-06-18', description: 'Revisión técnica de capítulos 1 a 12' },
      { id: 'EXP-006', concept: 'Maquetación preliminar LaTeX', category: 'RRHH', amount: 1500, date: '2026-07-02', description: 'Composición de índices y fórmulas tributarias' },
      { id: 'EXP-007', concept: 'Suministro Papel Premium Ahuesado', category: 'Físico', amount: 2200, date: '2026-07-20', description: 'Papelera Torraspapel - suministro especial' }
    ],
    status: 'pre-press',
    startDate: '2026-04-10',
    targetReleaseDate: '2026-09-01',
    notes: 'Proyecto por encargo para colectivo profesional con cobro por hitos (30% firma, 40% maqueta, 30% entrega tirada).',
    proposalDetails: {
      isSolicited: true,
      genre: 'Tratado Jurídico Tributario',
      collection: 'Manuales Universitarios Marcial Pons',
      synopsis: 'Actualización con la reforma de la Ley General Tributaria 2026 y jurisprudencia del Tribunal Supremo.',
      targetAudience: 'Estudiantes de Grado en Derecho, opositores a inspectores de hacienda y asesores fiscales.',
      proposalDate: '2026-03-01',
      agentOrAgency: 'Gabinete Jurídico Notarial',
      crmContactId: 'CRM-CL-008',
      crmSyncEnabled: true,
      presaleEnabled: true
    },
    zeroReader: {
      assignedReader: 'Prof. Javier Gómez (Catedrático)',
      deadline: '2026-03-25',
      report: {
        completed: true,
        narrativeQuality: 4,
        commercialViability: 5,
        technicalRigor: 5,
        catalogFit: 5,
        recommendation: 'publicar',
        evaluatorNotes: 'Obra de referencia esencial. Rigor doctrinal incuestionable con alta demanda en facultades de derecho.',
        evaluationDate: '2026-03-20'
      }
    },
    editorialBoardDecision: {
      decision: 'aprobado',
      decisionDate: '2026-03-28',
      comments: 'Aprobado con carácter preferente para coincidir con la apertura de curso en septiembre. Habilitar oferta vinculante en CRM.'
    },
    contractDetails: {
      status: 'docusign_sent',
      docusignEnvelopeId: 'DOCUSIGN-ENV-90142-TRIB',
      signedDate: undefined,
      advanceAmount: 3000,
      advanceAmortized: 0,
      advanceTreasuryPaid: false,
      royaltyTiers: [
        { upToQty: 1000, rate: 10 },
        { upToQty: 3000, rate: 12 },
        { upToQty: 999999, rate: 15 }
      ],
      territory: 'España',
      authorizedLanguages: ['Castellano'],
      authorizedFormats: ['Rústica', 'Digital'],
      durationYears: 5,
      exclusivity: true
    },
    technicalSheet: {
      subtitle: 'Comentarios, casos prácticos y esquemas de liquidación impositiva',
      translator: 'N/A',
      illustrator: 'N/A',
      isbnPrint: '978-84-15982-12-8',
      isbnDigital: '978-84-15982-13-5',
      legalDeposit: 'M-19034-2026',
      formatSize: '17 x 24 cm',
      pageCount: 780,
      paperType: 'Offset Blanco 70g',
      bindingType: 'Rústica cosida con solapas',
      coverLamination: 'Plastificado mate con golpe en seco'
    }
  },
  {
    id: 'PRJ-ED-03',
    name: 'La Sombra del Albatros: Crónicas del Atlántico',
    responsableId: 'USR-001',
    responsableName: 'Carlos Ruiz',
    bookTitle: 'La Sombra del Albatros: Crónicas del Atlántico Sur',
    bookAuthor: 'Ernesto Sabato (Inédito)',
    bookCategory: 'Narrativa Hispanoamericana',
    modality: 'propia',
    editorialPhase: 'evaluacion',
    formats: [
      { name: 'Rústica con Solapas', price: 21.50 },
      { name: 'E-book', price: 10.99 }
    ],
    tiradas: [
      { id: 'TIR-004', editionName: '1ª Tirada Lanzamiento', quantity: 3000, date: '2026-11-01' }
    ],
    humanResources: [],
    physicalResources: [],
    globalBudget: 15000,
    expenses: [],
    status: 'planning',
    startDate: '2026-07-01',
    targetReleaseDate: '2026-12-10',
    notes: 'Manuscrito inédito remitido por agencia. Actualmente en evaluación por Pedro con informe completado pendiente de Mesa Editorial.',
    proposalDetails: {
      isSolicited: false,
      genre: 'Ensayo Ficción Literaria',
      collection: 'Voces Mayores Albatross',
      synopsis: 'Manuscrito inédito rescatado de los diarios de viaje de 1974 por los mares australes con reflexiones sobre el existencialismo y la soledad.',
      targetAudience: 'Lectores de literatura iberoamericana y seguidores de la obra de Sabato.',
      proposalDate: '2026-07-10',
      agentOrAgency: 'Agencia Literaria Carmen Balcells (Barcelona)',
      crmContactId: 'CRM-AG-BALCELLS-01',
      crmSyncEnabled: true,
      presaleEnabled: false
    },
    zeroReader: {
      assignedReader: 'Pedro Sánchez (Director de Lectura)',
      deadline: '2026-08-15',
      report: {
        completed: true,
        narrativeQuality: 5,
        commercialViability: 4,
        technicalRigor: 5,
        catalogFit: 5,
        recommendation: 'publicar',
        evaluatorNotes: 'Extraordinaria fuerza lírica y valor histórico patrimonial indiscutible. Encaja a la perfección en el posicionamiento de prestigio de nuestro sello. Recomiendo aprobación inmediata en la próxima Mesa Editorial.',
        evaluationDate: '2026-08-02'
      }
    },
    editorialBoardDecision: {
      decision: 'pendiente',
      decisionDate: undefined,
      comments: 'Convocada la Mesa Editorial para votación colegiada este viernes.'
    },
    contractDetails: {
      status: 'draft',
      docusignEnvelopeId: undefined,
      signedDate: undefined,
      advanceAmount: 4000,
      advanceAmortized: 0,
      advanceTreasuryPaid: false,
      royaltyTiers: [
        { upToQty: 2000, rate: 8 },
        { upToQty: 5000, rate: 10 },
        { upToQty: 999999, rate: 12 }
      ],
      territory: 'España y Latinoamérica',
      authorizedLanguages: ['Castellano'],
      authorizedFormats: ['Rústica con Solapas', 'Audiolibro', 'E-book'],
      durationYears: 10,
      exclusivity: true
    }
  },
  {
    id: 'PRJ-ED-04',
    name: 'Cien Años de Soledad (Edición Centenario Ilustrada)',
    responsableId: 'USR-002',
    responsableName: 'Elena Martínez',
    bookTitle: 'Cien Años de Soledad',
    bookAuthor: 'Gabriel García Márquez',
    bookCategory: 'Realismo Mágico',
    modality: 'propia',
    editorialPhase: 'cierre',
    formats: [
      { name: 'Tapa Dura con Cinta de Registro', price: 28.00 },
      { name: 'Rústica Ilustrada', price: 18.50 }
    ],
    tiradas: [
      { id: 'TIR-005', editionName: 'Tirada Conmemorativa', quantity: 2500, date: '2026-04-10' }
    ],
    humanResources: [
      { id: 'HR-006', name: 'Ilustradora Luisa Rivera', estimatedHours: 120, hourlyCost: 35, totalEstimatedCost: 4200 }
    ],
    physicalResources: [
      { id: 'PHYS-005', name: 'Papel Guardas tintadas Munken', cost: 1800 }
    ],
    globalBudget: 16000,
    expenses: [
      { id: 'EXP-008', concept: 'Anticipo Derechos Herederos', category: 'Licencia', amount: 5000, date: '2026-03-01', description: 'Anticipo inicial amortizable' },
      { id: 'EXP-009', concept: 'Honorarios Ilustradora', category: 'RRHH', amount: 4200, date: '2026-04-15', description: 'Pago ilustraciones completas' },
      { id: 'EXP-010', concept: 'Factura Impresión Marcial Pons', category: 'Impresión', amount: 4850, date: '2026-06-01', description: 'Liquidación OT-2026-042' }
    ],
    status: 'completed',
    startDate: '2026-02-01',
    targetReleaseDate: '2026-06-15',
    notes: 'Tirada recibida en almacén central Madrid. En fase de cierre, distribución comercial y liquidación de royalties a herederos.',
    proposalDetails: {
      isSolicited: true,
      genre: 'Clásico Contemporáneo',
      collection: 'Obras Maestras Ilustradas',
      synopsis: 'La saga universal de la familia Buendía en Macondo con 50 ilustraciones inéditas a toda página.',
      targetAudience: 'Público general, coleccionistas y mercado internacional.',
      proposalDate: '2026-01-10',
      agentOrAgency: 'Agencia Carmen Balcells',
      crmContactId: 'CRM-AG-BALCELLS-01',
      crmSyncEnabled: true,
      presaleEnabled: true
    },
    zeroReader: {
      assignedReader: 'Pedro Sánchez',
      deadline: '2026-01-25',
      report: {
        completed: true,
        narrativeQuality: 5,
        commercialViability: 5,
        technicalRigor: 5,
        catalogFit: 5,
        recommendation: 'publicar',
        evaluatorNotes: 'Edición estelar con garantía de venta total en canales comerciales.',
        evaluationDate: '2026-01-20'
      }
    },
    editorialBoardDecision: {
      decision: 'aprobado',
      decisionDate: '2026-01-28',
      comments: 'Aprobación unánime con dotación presupuestaria máxima.'
    },
    contractDetails: {
      status: 'signed',
      docusignEnvelopeId: 'DOCUSIGN-ENV-77120-GGM',
      signedDate: '2026-02-12',
      advanceAmount: 5000,
      advanceAmortized: 3850,
      advanceTreasuryPaid: true,
      royaltyTiers: [
        { upToQty: 2000, rate: 8 },
        { upToQty: 5000, rate: 10 },
        { upToQty: 999999, rate: 12 }
      ],
      territory: 'España y Europa',
      authorizedLanguages: ['Castellano'],
      authorizedFormats: ['Tapa Dura', 'Rústica'],
      durationYears: 10,
      exclusivity: true
    },
    technicalSheet: {
      subtitle: 'Edición Conmemorativa Ilustrada',
      translator: 'N/A',
      illustrator: 'Luisa Rivera',
      isbnPrint: '978-84-15982-14-2',
      isbnDigital: '978-84-15982-15-9',
      legalDeposit: 'M-12093-2026',
      formatSize: '15 x 23 cm',
      pageCount: 496,
      paperType: 'Coral Book Ahuesado 90g',
      bindingType: 'Tapa dura al cromo con cinta de registro en seda verde',
      coverLamination: 'Soft-touch con estampado en oro'
    },
    imprimatur: {
      approved: true,
      signedBy: 'Elena Martínez & Pedro Sánchez',
      signedDate: '2026-05-15',
      versionNotes: 'OK definitivo a pruebas de color e imprimátur firmado sin observaciones.'
    },
    printJob: {
      otNumber: 'OT-2026-042',
      printShop: 'Marcial Pons Gráficas Industriales S.A.',
      contractedRun: 2500,
      effectiveDelivered: 2520, // +20 ejemplares (+0.8%), dentro de la tolerancia ±5%
      tolerancePercent: 5,
      otIssuedDate: '2026-05-18',
      receiptInWarehouseId: 'REC-001',
      status: 'recibido_almacen'
    },
    authorLiquidation: {
      period: '1er Semestre 2026 (Liquidación Semestral)',
      copiesSold: 1850,
      netRetailSales: 37925,
      grossRoyalties: 3850,
      advanceToAmortize: 3850,
      netPayable: 0,
      isLiquidated: true,
      liquidationDate: '2026-07-15',
      financeInvoiceGenerated: true
    }
  }
];
